import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Panel from '../../../../components/angle/Panel/index';
import { Glyphicon } from 'react-bootstrap';

class ItemListPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedIndex: ''
        };
    }
    componentWillReceiveProps(nextProps, nextContext) {
        if (this.props.itemList !== nextProps.itemList) {
            this.setState({ selectedIndex: '' });
        }
    }

    updateSelectedIndex = index => {
        this.setState({ selectedIndex: index });
    };
    render() {
        let {
            itemList,
            itemTypeName,
            onItemClick,
            onItemViewEditClick,
            displayAttributes
        } = this.props;
        return (
            <div>
                {itemList.length > 0 && (
                    <Panel panelStyle="panel-default m0">
                        <ul>
                            {itemList.map((item, index) => {
                                let updateSelectedIndex = this
                                    .updateSelectedIndex;
                                return (
                                    <li>
                                        <a
                                            className={
                                                index ===
                                                this.state.selectedIndex
                                                    ? 'active'
                                                    : ''
                                            }
                                            onClick={() => {
                                                onItemClick(item[itemTypeName]);
                                                updateSelectedIndex(index);
                                            }}
                                        >
                                            {displayAttributes.map(
                                                (attr, index, array) => {
                                                    let displayText =
                                                        item[attr];
                                                    if (
                                                        index !==
                                                        array.length - 1
                                                    ) {
                                                        displayText += ' - ';
                                                    }
                                                    return displayText;
                                                }
                                            )}
                                        </a>{' '}
                                        <a
                                            onClick={() =>
                                                onItemViewEditClick(
                                                    item[itemTypeName],
                                                    'view'
                                                )
                                            }
                                        >
                                            <Glyphicon glyph="eye-open" />
                                        </a>{' '}
                                        <a
                                            onClick={() =>
                                                onItemViewEditClick(
                                                    item[itemTypeName],
                                                    'edit'
                                                )
                                            }
                                        >
                                            <Glyphicon glyph="edit" />
                                        </a>
                                    </li>
                                );
                            })}
                        </ul>
                    </Panel>
                )}
            </div>
        );
    }
}

ItemListPanel.propTypes = {
    itemList: PropTypes.array.isRequired,
    itemTypeName: PropTypes.string.isRequired,
    onItemClick: PropTypes.func.isRequired,
    displayAttributes: PropTypes.array
};

ItemListPanel.defaultProps = {
    displayAttributes: ['name']
};

export default ItemListPanel;



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/QuickFilingRequest/ItemListPanel.js